// extracted by css-extract-rspack-plugin
export default {"cls1":"CurrentPaperRow-cls1__W1","cls2":"CurrentPaperRow-cls2___N CurrentPaperRow-cls1__W1"};